import React from 'react';
import { hexToRGB } from '../utils/colors';
import { UNLIMITED } from '../../dashboard/widgets/licensing/licensing-constants';

const Bar = ({ progressColor, progressPercent, textLeft }) => {
    const containerColor = hexToRGB(progressColor, '0.2');

    const progressWidth = progressPercent !== UNLIMITED ? `${progressPercent}%` : '100%';

    return (
        <div
            className="glu-bar"
            style={{
                background: containerColor
            }}
        >
            <div
                className="glu-progress"
                style={{
                    background: progressPercent === UNLIMITED ? progressColor : hexToRGB(progressColor, '0.8'),
                    borderRadius:
                        (progressPercent !== UNLIMITED && progressPercent < 100) ? '8px 0 0 8px' : '8px',
                    width: progressWidth
                }}
            >
                <span className="glu-progress__text">{textLeft}</span>
            </div>
        </div>
    );
};

export default Bar;
